import CryptoJS from 'crypto-js'

const AES_KEY = 'usabg'

const PREFILL_KEYS = [
  'pro_fname',
  'pro_lname',
  'pro_email',
  'pro_phone',
  'pro_mobile',
  'pro_address',
  'pro_city',
  'pro_state',
  'pro_zip',
]

const encryptValue = value =>
  value === undefined || value === null || value === ''
    ? ''
    : CryptoJS.AES.encrypt(value.toString(), AES_KEY).toString()

/**
 * Build the agent enrollment URL with AES-encrypted recruiterId / uplineId /
 * com_code, plus optional encrypted pre-fill query params for the new agent
 * form. Mirrors the URL shape produced by the original
 * EnrollmentLinkCreator.component.jsx so both code paths render identical
 * links.
 */
export const buildEnrollmentUrl = ({
  uLogin,
  recruiterId,
  uplineId,
  comCode,
  prefillData,
  origin,
  hideHeader,
  hideFooter,
  showAffiliate,
} = {}) => {
  const baseOrigin = origin || (typeof window !== 'undefined' && window.location ? window.location.origin : '')

  let url = `${baseOrigin}/${uLogin}/enroll`
  const params = []

  if (hideHeader) params.push('hide_header=1')
  if (hideFooter) params.push('hide_footer=1')

  const encRecruiterId = encryptValue(recruiterId)
  const encUplineId = encryptValue(uplineId)
  const encComCode = encryptValue(comCode)

  if (encRecruiterId) params.push(`recruiterId=${encRecruiterId}`)
  if (encUplineId) params.push(`uplineId=${encUplineId}`)
  if (encComCode) params.push(`com_code=${encComCode}`)

  // `show_affiliate` is appended unencrypted (plain `show_affiliate=1`) to match
  // the plain-text reader in EnrollmentPage._checkShowAffiliate. It's a display
  // flag, not an identity, so encryption would be ceremony without value.
  if (showAffiliate) params.push('show_affiliate=1')

  if (prefillData && typeof prefillData === 'object') {
    PREFILL_KEYS.forEach(key => {
      const enc = encryptValue(prefillData[key])
      if (enc) params.push(`${key}=${enc}`)
    })
  }

  if (params.length > 0) url += `?${params.join('&')}`
  return url
}

export const encryptEnrollmentValue = encryptValue
